/* ELMORVA: desktop thumbnail rail for Horizon's product media gallery.
   Drives Horizon's own <slideshow-component> (select) and leaves its zoom
   dialog, variant handling and mobile carousel untouched.
   Horizon replaces the whole <media-gallery> on variant change, so this
   watches the document and rebuilds rather than holding references. */
(function () {
  var MQ = window.matchMedia('(min-width: 990px)');
  var timer = null;

  function thumbSrc(img) {
    var s = img.getAttribute('src') || img.currentSrc || '';
    if (!s) return '';
    if (/[?&]width=\d+/.test(s)) return s.replace(/([?&]width=)\d+/, '$1200');
    return s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=200';
  }

  function sync(g) {
    var dots = [].slice.call(g.querySelectorAll('.slideshow-controls__dots button'));
    var btns = [].slice.call(g.querySelectorAll('.ev-thumbs__b'));
    var active = 0;
    for (var i = 0; i < dots.length; i++) {
      if (dots[i].getAttribute('aria-selected') === 'true') { active = i; break; }
    }
    btns.forEach(function (b, i) {
      b.setAttribute('aria-current', i === active ? 'true' : 'false');
    });
  }

  function build(g) {
    if (!MQ.matches) return;
    if (!g.querySelector('slideshow-component')) return;
    var slides = [].slice.call(g.querySelectorAll('slideshow-slide'));
    var rail = g.querySelector('.ev-thumbs');
    if (slides.length < 2) { if (rail) rail.remove(); return; }

    var srcs = slides.map(function (s) {
      var i = s.querySelector('img');
      return i ? thumbSrc(i) : '';
    });
    var key = srcs.join('|');
    if (rail && rail.dataset.key === key) { sync(g); return; }
    if (rail) rail.remove();

    rail = document.createElement('div');
    rail.className = 'ev-thumbs';
    rail.dataset.key = key;
    srcs.forEach(function (src, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ev-thumbs__b';
      b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + srcs.length);
      if (src) {
        var t = document.createElement('img');
        t.src = src;
        t.alt = '';
        t.width = 200;
        t.height = 200;
        b.appendChild(t);
      }
      b.addEventListener('click', function () {
        var host = b.closest('media-gallery');
        var s = host && host.querySelector('slideshow-component');
        if (s && typeof s.select === 'function') s.select(i);
      });
      rail.appendChild(b);
    });
    g.querySelector('slideshow-component').insertAdjacentElement('afterend', rail);
    sync(g);
  }

  function run() {
    [].slice.call(document.querySelectorAll('media-gallery')).forEach(build);
  }

  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; run(); }, 60);
  }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['aria-selected']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  if (MQ.addEventListener) MQ.addEventListener('change', run);
})();
